<form #userForm="ngForm">
    <div class="container-fluid form-container" *ngIf="user">
        <h2 class="heading-personal">{{ 'user.data' | translate }}</h2>
        <hr>
        <div class="error-box">
            <span *ngIf="errorUser" class="error col-12">
                {{ 'user.error_new_user' | translate }}
            </span>
            <span *ngIf="error" class="error col-12">
                {{ ('errors.error_super_user' | translate) }}
                <a [href]="goToCompanyDetailUrl(user.companyId)">
                    {{ 'Details' }}
                </a>
            </span>
        </div>
        <div class="row">
            <div
                *ngIf="user.email !== currentAdmin.email"
                class="col-12 col-xl-6 mb-3"
                [ngClass]="{'hidden': permissionCheck}"
            >
                <label for="">{{ 'user.position' | translate }}</label>
                <ng-select
                    name="role"
                    [items]="roles"
                    [clearable]="false"
                    [searchable]="true"
                    [(ngModel)]="user.role"
                    bindValue="code"
                    bindLabel="name"
                    [editableSearchTerm]="true"
                    required
                    [disabled]="disableForm ? '' : null"
                >
                </ng-select>
            </div>
            <div
                *ngIf="user.awaitingActivation == 1"
                class="col-12 col-xl-8 mb-3 d-flex align-items-end"
            >
                <input
                    type="checkbox"
                    [(ngModel)]="awaitingActivation"
                >
                <label for="">{{ 'user.approve' | translate }}</label>
            </div>
            <div
                *ngIf="user.awaitingActivation == 0 && !userSameAsAdmin()"
                class="col-12 col-xl-8 mb-3 d-flex align-items-end"
            >
                <div class="d-flex" *ngIf="!permissionCheck" >
                    <div class="d-block">
                        <label class="radio radio-gradient">
                            <span class="radio__input">
                                <input
                                    type="radio"
                                    name="active"
                                    [value]="1"
                                    [(ngModel)]="user.active"
                                />
                                <span class="radio__control"></span>
                            </span>
                            <span class="radio__label"
                                >{{ 'user.active' | translate }}</span
                            >
                        </label>
                    </div>
                    <div class="d-block ms-4">
                        <label class="radio radio-before">
                            <span class="radio__input">
                                <input
                                    type="radio"
                                    name="active"
                                    [value]="0"
                                    [(ngModel)]="user.active"
                                    [disabled]="disableForm ? '' : null"
                                />
                                <span class="radio__control"></span>
                            </span>
                            <span class="radio__label"
                                >{{ 'user.inactive' | translate }}</span
                            >
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-12 col-xl-6 mb-3">
                <label for="">{{ 'user.name' | translate }}</label>
                <input
                    name="firstName"
                    type="text"
                    class="form-control"
                    [(ngModel)]="user.firstName"
                    pattern="^([^\$%\^*£=~@\d]+)+$"
                    required
                    #firstName="ngModel"
                    [disabled]="disableForm ? '' : null"
                />
                <div *ngIf="firstName.errors?.pattern" class="error_input">
                    {{ 'errors.error_name' | translate }}
                </div>
            </div>
            <div class="col-12 col-xl-6 mb-3">
                <label for="">{{ 'user.lastname' | translate }}</label>
                <input
                    name="lastname"
                    type="text"
                    class="form-control"
                    [(ngModel)]="user.lastName"
                    pattern="^([^\$%\^*£=~@\d]+)+$"
                    required
                    #lastName="ngModel"
                    [disabled]="disableForm ? '' : null"
                />
                <div *ngIf="lastName.errors?.pattern" class="error_input">
                    {{ 'errors.error_name' | translate }}
                </div>
            </div>
            <div class="col-12 col-xl-6 mb-3">
                <label for="">{{ 'user.email' | translate }}</label>
                <input
                    name="email"
                    type="email"
                    class="form-control"
                    [(ngModel)]="user.email"
                    pattern='^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
                    required
                    #email="ngModel"
                    [disabled]="disableForm ? '' : null"
                />
                <div *ngIf="email.errors?.pattern" class="error_input">
                    {{ 'errors.error_email' | translate }}
                </div>
            </div>
            <div class="col-8 col-xl-3 mb-3">
                <label for="">{{ 'user.phone' | translate }}</label>
                <input
                    name="phone"
                    type="text"
                    class="form-control"
                    [(ngModel)]="user.phone"
                    pattern="^(00)(([0-9])([\/\s-])?)+$"
                    #phone="ngModel"
                    [disabled]="disableForm ? '' : null"
                />
                <div *ngIf="phone.errors?.pattern" class="error_input">
                    {{ 'errors.error_phone' | translate }}
                </div>
            </div>
            <div class="col-4 col-xl-3 mb-3">
                <label for="">{{ 'user.language' | translate }}</label>
                <ng-select
                    name="language"
                    [items]="languages"
                    [clearable]="false"
                    [searchable]="true"
                    bindValue="code"
                    bindLabel="name"
                    [(ngModel)]="user['language']"
                    [editableSearchTerm]="true"
                    required
                    [disabled]="disableForm ? '' : null"
                >
                </ng-select>
            </div>
            <div
                class="
                    col-12
                    mt-2
                    mb-2
                    text-center
                    mt-md-4
                    mb-md-4
                    button-container-personal
                "
                *ngIf="user.id && user.id != null && user.id !== null && user.active === 1"
            >
                <!-- <div
                    class="btn btn-primary me-2 mb-2"
                    [style]="{width: 'auto', padding: '6px 28px'}"
                    (click)="resendActivationEmail()"
                >
                    {{ 'user.btn_activation_email' | translate }}
                </div> -->
                <div
                    class="btn btn-primary me-2 mb-2"
                    [style]="{width: 'auto', padding: '6px 28px'}"
                    (click)="forgotPasswordEmail()"
                >
                    {{ 'user.btn_forgott_pwd' | translate }}
                </div>
            </div>
        </div>
        <div class="row flex-column align-items-start">
            <h2
                class="col-xl-8 heading-company"
            >
                {{ 'user.company' | translate }}
            </h2>
            <hr>
            <div class="col-12 col-xl-8">
                <div class="mb-3">
                    <label for="">{{ 'user.country' | translate }}</label>
                    <ng-select
                        name="country"
                        [items]="countries"
                        [(ngModel)]="country"
                        [clearable]="false"
                        [searchable]="true"
                        bindValue="code"
                        bindLabel="name"
                        [editableSearchTerm]="true"
                        required
                        (change)="filterCities()"
                        [disabled]="disableForm ? '' : null"
                    >
                    </ng-select>
                </div>
                <div class="mb-3">
                    <label for="">{{ 'user.city' | translate }}</label>
                    <ng-select
                        name="city"
                        [items]="cities"
                        [(ngModel)]="city"
                        [clearable]="false"
                        [searchable]="true"
                        bindValue="name"
                        bindLabel="name"
                        [editableSearchTerm]="true"
                        required
                        [readonly]="country === null"
                        (change)="filterCompanies()"
                        #cityNgSelectComponent
                        [disabled]="disableForm ? '' : null"
                    >
                    </ng-select>
                </div>
                <div class="mb-3">
                    <label for="">{{ 'user.company' | translate }}</label>
                    <ng-select
                        name="companyId"
                        [items]="selectableCompanies"
                        [(ngModel)]="user.companyId"
                        [clearable]="false"
                        [searchable]="true"
                        bindValue="id"
                        bindLabel="name"
                        [editableSearchTerm]="true"
                        required
                        [readonly]="city === null || selectableCompanies.length === 0"
                        #companyNgSelectComponent
                        [disabled]="disableForm ? '' : null"
                    >
                    </ng-select>
                </div>
            </div>
        </div>

        <div class="row mt-4 justify-content-center">
            <div class="col-12 text-center button-container">
                <div
                    (click)="goBack()"
                    class="btn btn-outline-primary me-2 mb-2"
                >
                    {{ 'user.btn_back' | translate }}
                </div>
                <button
                    type="button"
                    class="btn btn-primary me-2 mb-2"
                    (click)="saveUser(user)"
                    [disabled]="!(userForm.valid)"
                    [disabled]="disableForm ? '' : null"
                >
                    {{ 'user.btn_save' | translate }}
                </button>
            </div>
        </div>
    </div>
    <div
        *ngIf="emailSent || disableForm"
        class="modal-container"
        (click)="disableForm ? goBack() : closeModal()"
    >
        <div class="modal-content text-center">
            <div *ngIf="!disableForm" class="close-btn" >
                <img src="../../../assets/icons/close.png" alt="" />
            </div>
            <h2 class="d-flex justify-content-center align-items-center">
                <span class="p-2">{{ modalText | translate }}</span>
                <div *ngIf="disableForm && !onlyMowaAdmin" class="loader"></div>
            </h2>
        </div>
    </div>
</form>
